import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Api } from "../../../utils/Variables";
import { makeUrl } from "../../../utils";

const Featured = ({
  item,
  id,
  image,
  image1,
  title,
  amount,
  addToCart,
  addToWishlist,
  isInWishlist,
}) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      <div className="card-product-wrapper text-center">
        <div>
          {item.salesdiscount > 0 && (
            <div className="st-flat-discount">
              <span className="flat-discount-text">
                {Math.floor(item.salesdiscount)}%
                <span style={{ fontSize: "9px" }}>discount</span>
              </span>
            </div>
          )}

          <Link to={`/${makeUrl(item.slug)}/p/${id}`} className="product-img">
            <img
              className="img-product"
              src={Api.CloudImageUrl + image}
              alt={title}
              onLoad={() => setLoaded(true)}
              loading="lazy"
              style={{ height: "320px", objectFit: "cover" }}
            />
            <img
              className="img-hover"
              src={Api.CloudImageUrl + image1}
              alt={title}
              loading="lazy"
              style={{ height: "320px", objectFit: "cover" }}
            />
          </Link>

          <div className="list-product-btn absolute-2">
            {item.stockinhand && parseFloat(item.stockinhand) > 0 ? (
              <a
                onClick={() => addToCart(item)}
                className="box-icon bg_white quick-add"
              >
                <span className="icon icon-bag"></span>
                <span className="tooltip">Add to Cart</span>
              </a>
            ) : (
              <span className="out-of-stock text-danger small text-white fw-bolder">
                Out of Stock
              </span>
            )}

            {item.stockinhand && parseFloat(item.stockinhand) > 0 && (
              <a
                onClick={addToWishlist}
                className="box-icon bg_white quick-add"
              >
                <i
                  className={
                    isInWishlist ? "fa fa-heart text-danger" : "icon-heart"
                  }
                ></i>
                <span className="tooltip">
                  {isInWishlist ? "Remove from Wishlist" : "Add to Wishlist"}
                </span>
              </a>
            )}
          </div>
        </div>
      </div>

      <div className="card-product-info">
        <Link to={`/${makeUrl(item.slug)}/p/${id}`} className="title link">
          {title.length > 25 ? title.slice(0, 25) + "..." : title}
        </Link>
        <span className="rice current-price">
          ₹ {amount} |{" "}
          <span style={{ fontSize: "10px" }}>Code: {item.hsn}</span>
        </span>
      </div>
    </>
  );
};

export default Featured;
